import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import WelcomePage from './components/WelcomePage/WelcomePage';
import ProtectedRoute from './components/WelcomePage/ProtectedRoute/ProtectedRoute.jsx';

const Dashboard = lazy(() => import('./components/Dashboard/Dashboard.jsx'));
const SignupWithEmail = lazy(() => import('./components/WelcomePage/Signup/Signup'));
const Signin = lazy(() => import('./components/WelcomePage/Signin/Signin'));
const PasswordRetrieve = lazy(() => import('./components/WelcomePage/Signin/PasswordRetrieve/PasswordRetrieve'));
const AccountSettings = lazy(() => import('./components/Dashboard/Account-Settings/Account-Settings'));
const AboutPage = lazy(() => import('./components/WelcomePage/AboutPage/AboutPage.jsx'));
const GoPremium = lazy(() => import('./components/CheckoutForm/CheckoutForm.jsx'));
const VerificationPage = lazy(() => import('./components/WelcomePage/Signup/VerificationPage/VerificationPage.jsx'));
const GuestChatPage = lazy(() => import('./components/WelcomePage/GuestChatPage/GuestChatPage.jsx'));
const PrivacyPolicy = lazy(() => import('./components/WelcomePage/PrivacyPolicy/PrivacyPolicy.jsx'));
const MyDates = lazy(() => import('./components/Dashboard/MyDates/MyDates.jsx'));
const Admin = lazy(() => import('./components/Admin/Admin.jsx'));

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
            <Route path="/signup" element={<SignupWithEmail />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/password-retrieve" element={<PasswordRetrieve />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/mydates" element={<MyDates />} />
            <Route path="/admin" element={<ProtectedRoute element={Admin} adminOnly />} />
            <Route path="/go-premium" element={<GoPremium />} />
            <Route path="/verification" element={<VerificationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/guestchat" element={<GuestChatPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
